export default "__VITE_ASSET__1v0AqR0qVC6WAjKyAFdnew__"